import type { SkillSummary, WorkflowSkill } from '@heidi/agents/contracts';
import { toSkillSlug } from './skill-slug';

export function deriveAvailableWorkflowSkillsFromSummaries(
  summaries: readonly SkillSummary[]
): readonly WorkflowSkill[] {
  return summaries.flatMap((summary) =>
    summary.status === 'ready' && summary.skillId
      ? [
          {
            skillId: summary.skillId,
            recordingId: summary.recordingId,
            slug: toSkillSlug(summary.title),
            title: summary.title,
          },
        ]
      : []
  );
}
